import { jsxs as u, jsx as o } from "react/jsx-runtime";
import i from "../../components/Button/index.js";
import c from "../../icons/Minus.js";
import l from "../../icons/Plus.js";
const m = "forma-ui__quantity__root", y = "forma-ui__quantity__button", _ = "forma-ui__quantity__buttonIcon", p = "forma-ui__quantity__input", t = {
  root: m,
  button: y,
  buttonIcon: _,
  input: p
}, q = ({ value: n = 0, max: e = 100, onChange: r, disabled: s }) => /* @__PURE__ */ u("div", { className: t.root, children: [
  /* @__PURE__ */ o(
    i,
    {
      viewStyle: "tertiary",
      className: t.button,
      onClick: () => n > 0 && r(n - 1),
      iconClassName: t.buttonIcon,
      icon: /* @__PURE__ */ o(c, {}),
      disabled: s
    }
  ),
  /* @__PURE__ */ o(
    "input",
    {
      type: "text",
      className: t.input,
      value: n,
      pattern: "[0-9]*",
      onChange: (a) => {
        Number(a.target.value) > e ? r(e) : r(Number(a.target.value.replaceAll(/[^0-9]/g, "")));
      },
      disabled: s
    }
  ),
  /* @__PURE__ */ o(
    i,
    {
      viewStyle: "tertiary",
      className: t.button,
      onClick: () => n < e && r(n + 1),
      iconClassName: t.buttonIcon,
      icon: /* @__PURE__ */ o(l, {}),
      disabled: s
    }
  )
] }), v = () => /* @__PURE__ */ u("div", { className: t.root, children: [
  /* @__PURE__ */ o(
    i,
    {
      viewStyle: "tertiary",
      className: t.button
    }
  ),
  /* @__PURE__ */ o("span", { className: t.input }),
  /* @__PURE__ */ o(
    i,
    {
      viewStyle: "tertiary",
      className: t.button
    }
  )
] });
export {
  v as QuantityPlaceholder,
  q as default
};
